import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import {
  deleteCourseFees,
  getColleges,
  getCourseCategories,
  getCourseFees,
  getCourses,
  getUniversities,
  topCourseFees,
  topCourseFeesStatus,
  topFeaturedCourseStatus,
  updateCourseFees,
} from "../../Services/HomeService";
import moment from "moment";
import HttpClientXml from "../../utils/HttpClientXml";
import Swal from "sweetalert2";
import "./Style.css";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const options = [
  { value: "JEE Main", label: "JEE Main" },
  { value: "JEE Advanced", label: "JEE Advanced" },
  { value: "WB JEE", label: "WB JEE" },
];

const ManageCourseAndFees = () => {
  const location = useLocation();
  const { college } = location.state || {};

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const data = [
    {
      state: "West Bangal",
      district: "North 24 Parganas",
      cityName: "Madhyamgram",
      type: "college",
      universityName: "Sikkim Manipal University",
      collegeName: "Lee Sun College",
      courseCategory: "Engineering",
      courseName: "Rocket Science",
      name: "Lee Sun College",
      shortDescription: "This is a good college",
      //   state: "West Bengal",
      //   district: "North 24 Parganas",
      address: "Barasat",
      pin: "700155",
      privateOrGovt: "Govt",
      estd: "1990",
      fees: "2600000",
      universityName: "Sikkim Manipal University",
      eligibility: "12th pass",
      applicationDate: "12th August 2025",

      longDescription:
        "hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello ",
    },
  ];

  const initialValues = {
    type: "College", //or "University"
    universityId: "",
    collegeId: "",
    categoryId: "",
    courseDegreeId: "",
    eligibility: "",
    fees: 0,
    applicationDate: moment().format("YYYY-MM-DD"),
    brochure: "",
    courseMode: "", //online/offline
    durationYear: 0,
    durationMonth: 0,
    /////
    studyMode: "Regular", //Regular,Distance
    shortEligibility: "",
    longEligibility: "",
    shortDescription: "",
    particulars: "",
    dayScholars: "",
    entranceExamAccepted: [],
    yearWiseFees: [
      {
        year: 1,
        fees: 0,
      },
    ],
  };

  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] =
    useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] =
    useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [formData, setFormData] = useState(initialValues);

  const [fetchLoading, setFetchLoading] = useState(false);
  const [allData, setAllData] = useState([]);

  const fetchAllData = async () => {
    try {
      setFetchLoading(true);
      const res = await getCourseFees();
      console.log("fetched Course Fees", res?.data);
      if (res?.status) {
        if (college) {
          setAllData(
            res?.data.filter((item) => item.college._id === college?.collegeid)
          );
          setFilteredData(
            res?.data.filter((item) => item.college._id === college?.collegeid)
          );
        } else {
          setAllData(res?.data);
          setFilteredData(res?.data);
        }

        setFetchLoading(false);
      } else {
        toast.error("Error while Fetching Course Fees Data");
        setFetchLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Fees Data");
      console.error("Error fetching Course Fees:", error);
      setFetchLoading(false);
    }
  };

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data.filter((item) => item.categoryId === categoryId));
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    setUploading(true);
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, brochure: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false);
      fileInputRef.current.value = null;
    }
  };

  const handleEdit = (data) => {
    // console.log("CDE91", data);
    setUpdateId(data?._id);

    const displayData = {
      type: data?.type || "",
      universityId: data?.university?._id || "",
      collegeId: data?.college?._id || "",
      categoryId: data?.category?._id || "",
      courseDegreeId: data?.courseDegree?._id || "",
      eligibility: data?.eligibility || "",
      fees: data?.fees || 0,
      applicationDate: moment(data?.applicationDate).format("YYYY-MM-DD"),
      brochure: data?.brochure || "",
      courseMode: data?.courseMode || "",
      durationYear: data?.durationYear || 0,
      durationMonth: data?.durationMonth || 0,
      ///
      studyMode: data?.studyMode || "",
      // shortEligibility:data?.shortEligibility || "",
      longEligibility: data?.longEligibility || "",
      shortDescription: data?.shortDescription || "",
      particulars: data?.particulars || "",
      dayScholars: data?.dayScholars || "",
      entranceExamAccepted: data?.entranceExamAccepted || [],
      yearWiseFees: data?.yearWiseFees,
    };
    const options = data?.entranceExamAccepted?.map((exam) => ({
      value: exam,
      label: exam,
    }));

    setSelectedExams(options);
    console.log("KIU246", data?.entranceExamAccepted, options);

    setFormData(displayData);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Course Fees?",
      text: "Are you sure you want to delete this Course Fees?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCourseFees(id);
        Swal.fire("Deleted!", "Course Fees has been deleted.", "success");
        fetchAllData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Course Fees.", "error");
      }
    }
  };

  const handleTopCourse = async (id, status) => {
    const formData = {
      courseId: id,
      isTopCourse: status,
    };

    console.log("LOI305", college);
    // return
    try {
      await topCourseFeesStatus(formData);
      toast.success("Status updated.");
      setSearch("");
      fetchAllData();
    } catch (error) {
      Swal.fire("Error!", "Failed to delete Course Fees.", "error");
    }
  };

  const handleFeaturedCourse = async (id, status) => {
    const formData = {
      courseId: id,
      isFeaturedCourse: status,
    };

    console.log("LOI305", college);
    // return
    try {
      await topFeaturedCourseStatus(formData);
      toast.success("Status updated.");
      setSearch("");
      fetchAllData();
    } catch (error) {
      Swal.fire("Error!", "Failed to delete Course Fees.", "error");
    }
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    // {
    //   name: "Type",
    //   selector: (row) => row?.type,
    //   sortable: true,
    // },
    {
      name: "Top",
      center: true,
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-success"
            style={{
              minWidth: "100px",
              backgroundColor: `${row?.isTopCourse ? "green" : "red"}`,
            }}
            type="button"
            onClick={() => handleTopCourse(row?._id, !row?.isTopCourse)}
          >
            {row?.isTopCourse ? "Yes" : "No"}
          </button>
        </>
      ),
    },
    {
      name: "Featured",
      center: true,
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-success"
            style={{
              minWidth: "100px",
              backgroundColor: `${row?.isFeaturedCourse ? "green" : "red"}`,
            }}
            type="button"
            onClick={() =>
              handleFeaturedCourse(row?._id, !row?.isFeaturedCourse)
            }
          >
            {row?.isFeaturedCourse ? "Yes" : "No"}
          </button>
        </>
      ),
    },
    {
      name: "University",
      selector: (row) => row?.university?.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "College",
      selector: (row) => row?.college?.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Category",
      selector: (row) => row?.category?.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Course",
      selector: (row) => row?.courseDegree?.degreeName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Mode",
      selector: (row) => (
        <>
          <span className="courseMode">{row?.courseMode}</span>
        </>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Fees",
      selector: (row) => (
        <>
          <i className="fa fa-inr" aria-hidden="true"></i> {row?.fees}
        </>
      ),
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => (
        <>
          {row?.durationYear > 0 && (
            <>
              {row?.durationYear} Year{row?.durationYear > 1 && "s"}
            </>
          )}
          {row?.durationMonth > 0 && (
            <>
              <br />
              {row?.durationMonth} Month{row?.durationMonth > 1 && "s"}
            </>
          )}
        </>
      ),
      wrap: true,
    },
    {
      name: "Eligibility",
      selector: (row) => row.eligibility,
      sortable: true,
      wrap: true,
    },
    {
      name: "Application Date",
      selector: (row) => moment(row.applicationDate).format("DD-MM-YYYY"),
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleEdit(row)}
            ></i>
          </span>
          <span title="Delete">
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleDelete(row?._id)}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setUpdateId(null);
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    if (
      !formData?.type ||
      !formData?.universityId ||
      !formData?.collegeId ||
      !formData?.categoryId ||
      !formData?.courseDegreeId ||
      !formData?.eligibility ||
      !formData?.fees ||
      !formData?.applicationDate ||
      !formData?.courseMode
      // !formData?.brochure
    ) {
      toast.error("Please Enter All Fields");
      return;
    }

    console.log("VFT412", formData);
    // return

    try {
      setUpdateLoading(true);
      const res = await updateCourseFees(updateId, formData);
      console.log("Course Fees Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues);
        setUpdateId(null);
        setUpdateLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Course Fees.");
      console.error("Error adding Course Fees:", error);
      setUpdateLoading(false);
    } finally {
      fetchAllData();
    }
  };

  useEffect(() => {
    fetchAllData();
    fetchUniversities();
    fetchColleges();
    fetchCourseCategories();
  }, []);

  useEffect(() => {
    fetchCourses(formData.categoryId);
  }, [formData.categoryId]);

  const [selectedExams, setSelectedExams] = useState([]);

  useEffect(() => {
    const values = selectedExams?.map((opt) => opt.value);
    setFormData({ ...formData, entranceExamAccepted: values });
  }, [selectedExams]);

  //////////////////////////
  /////////////////////////////////////
  const initialItem = {
    year: 1,
    fees: 0,
  };

  const initialItems = formData?.yearWiseFees ||
    data?.yearWiseFees || [initialItem];
  console.log("OIU464", data?.yearWiseFees);

  const [items, setItems] = useState(formData?.yearWiseFees);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...items];
    newFormValues[i][e.target.name] = parseInt(e.target.value);
    setItems(newFormValues);
    setFormData({ ...formData, yearWiseFees: newFormValues });
  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, yearWiseFees: newFormValues });
  };

  useEffect(() => {
    setItems(formData?.yearWiseFees || [initialItem]);
  }, [formData]);

  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState(allData);

  useEffect(() => {
    const filteredData = allData.filter((item) => {
      return (
        item?.university?.name?.toLowerCase().includes(search.toLowerCase()) ||
        item?.college?.name?.toLowerCase().includes(search.toLowerCase()) ||
        item?.category?.name?.toLowerCase().includes(search.toLowerCase()) ||
        item?.courseDegree?.degreeName
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item?.courseMode?.toLowerCase().includes(search.toLowerCase()) ||
        item?.eligibility?.toLowerCase().includes(search.toLowerCase())
      );
    });
    if (search.trim()) {
      setFilteredData(filteredData);
    } else {
      setFilteredData(allData);
    }
  }, [search]);

  return (
    <div>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage Course and Fees
            {/* {college?.collegename && <><h4>{college?.collegename}</h4></>} */}
          </div>
          {updateId ? (
            <>
              <section className="chartBox_area">
                <form
                  onSubmit={(e) => {
                    handleUpdate(e);
                  }}
                >
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-3 mt-3">
                      <label htmlFor="name">
                        Select Type<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={formData?.type}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            type: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="">-------- Select Type --------</option>
                        <option value="College">College</option>
                        <option value="University">University</option>
                      </select>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label htmlFor="name">
                        Study Mode<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={formData?.studyMode}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            studyMode: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="">-------- Select Mode --------</option>
                        <option value="Regular">Regular</option>
                        <option value="Distance">Distance</option>
                      </select>
                    </div>
                    {/* <div className="col-md-6 mt-3">
                                <label htmlFor="name">
                                  University Name<span className="text-danger">*</span>
                                </label>
                                <select className="form-control">
                                  <option value="">
                                    -------- Select University --------
                                  </option>
                                  <option value="">Sikkim Manipal University</option>
                                  <option value="">Swami Vivekananda University</option>
                                  <option value="">
                                    Maulana Abul Kalam Azad University Of Technology
                                  </option>
                                  <option value="">Jadhavpur University</option>
                                </select>
                              </div> */}

                    <div
                      className="col-md-6 mt-3"
                      // style={{
                      //   display:
                      //     formData?.type === "College" ? "" : "none",
                      // }}
                    >
                      <label htmlFor="name">
                        University Name<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            universityId: e?.target?.value,
                          }));
                        }}
                        value={formData?.universityId}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select University --------
                        </option>
                        {fetchUniversitiesLoading ? (
                          <option>Loading...</option>
                        ) : universities?.length === 0 ? (
                          <option>No University Found</option>
                        ) : (
                          universities?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.name}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>

                    {/* <div className="col-md-6 mt-3">
                                <label htmlFor="name">
                                  College Name<span className="text-danger">*</span>
                                </label>
                                <select className="form-control">
                                  <option value="">-------- Select College --------</option>
                                  <option value="">Lee Sun College</option>
                                  <option value="">
                                    Regent Education and Research Foundation
                                  </option>
                                  <option value="">Vivekananda College</option>
                                  <option value="">Jadhavpur College</option>
                                </select>
                              </div> */}
                    <div
                      className="col-md-6 mt-3"
                      // style={{
                      //   display:
                      //     formData?.type === "College" ? "" : "none",
                      // }}
                    >
                      <label htmlFor="name">
                        College Name<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            collegeId: e?.target?.value,
                          }));
                        }}
                        value={formData?.collegeId}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select College --------
                        </option>
                        {fetchCollegesLoading ? (
                          <option>Loading...</option>
                        ) : colleges?.length === 0 ? (
                          <option>No College Found</option>
                        ) : (
                          colleges?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.name}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>

                    {/* <div className="col-md-6 mt-3">
                                <label htmlFor="name">
                                  Course Category<span className="text-danger">*</span>
                                </label>
                                <select className="form-control">
                                  <option value="">
                                    -------- Select Course Category --------
                                  </option>
                                  <option value="">Engineering</option>
                                  <option value="">Administration</option>
                                  <option value="">Finance</option>
                                  <option value="">Rocket Science</option>
                                </select>
                              </div> */}
                    <div
                      className="col-md-6 mt-3"
                      // style={{
                      //   display:
                      //     formData?.type === "College" ? "" : "none",
                      // }}
                    >
                      <label htmlFor="name">
                        Course Category<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            categoryId: e?.target?.value,
                          }));
                        }}
                        value={formData?.categoryId}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select Course Category --------
                        </option>
                        {fetchCourseCategoriesLoading ? (
                          <option>Loading...</option>
                        ) : courseCategories?.length === 0 ? (
                          <option>No Category Found</option>
                        ) : (
                          courseCategories?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.name}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>

                    {/* <div className="col-md-6 mt-3">
                                <label htmlFor="name">
                                  Course Name<span className="text-danger">*</span>
                                </label>
                                <select className="form-control">
                                  <option value="">
                                    -------- Select Course Name --------
                                  </option>
                                  <option value="">Computer Engineering</option>
                                  <option value="">Business Administration</option>
                                  <option value=""> Finance</option>
                                  <option value="">Robotics Science</option>
                                </select>
                              </div> */}
                    <div
                      className="col-md-6 mt-3"
                      // style={{
                      //   display:
                      //     formData?.type === "College" ? "" : "none",
                      // }}
                    >
                      <label htmlFor="name">
                        Course Name<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            courseDegreeId: e?.target?.value,
                          }));
                        }}
                        value={formData?.courseDegreeId}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select Course Name --------
                        </option>
                        {fetchCoursesLoading ? (
                          <option>Loading...</option>
                        ) : courses?.length === 0 ? (
                          <option>No Course Found</option>
                        ) : (
                          courses?.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.degreeName}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Mode<span className="text-danger">*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px", // spacing between radio options
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="courseMode"
                            value="offline"
                            checked={formData?.courseMode === "offline"}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                courseMode: e?.target?.value,
                              }))
                            }
                          />
                          Offline
                        </label>

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="courseMode"
                            value="online"
                            checked={formData?.courseMode === "online"}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                courseMode: e?.target?.value,
                              }))
                            }
                          />
                          Online
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Total Fees<span className="text-danger">*</span>
                      </label>
                      {/* <input
                                  type="text"
                                  id="name"
                                  className="form-control"
                                  value={formData?.fees}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      fees: parseInt(e?.target?.value),
                                    }));
                                  }}
                                  placeholder="Enter Fees"
                                  required
                                /> */}
                      <input
                        type="number"
                        min="0"
                        id="name"
                        className="form-control"
                        value={formData?.fees}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "") {
                            setFormData((prev) => ({
                              ...prev,
                              fees: "",
                            }));
                          } else {
                            const numericValue = parseInt(value);
                            if (!isNaN(numericValue)) {
                              setFormData((prev) => ({
                                ...prev,
                                fees: numericValue,
                              }));
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                          ];
                          if (
                            !/[0-9]/.test(e.key) &&
                            !allowedKeys.includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Fees"
                        required
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Duration<span className="text-danger">*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px", // spacing between radio options
                          alignItems: "center",
                          // marginTop: "8px"
                        }}
                      >
                        <input
                          type="number"
                          min="0"
                          name="durationYear"
                          className="form-control"
                          value={formData?.durationYear}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setFormData((prev) => ({
                                ...prev,
                                durationYear: "",
                              }));
                            } else {
                              const numericValue = parseInt(value);
                              if (!isNaN(numericValue)) {
                                setFormData((prev) => ({
                                  ...prev,
                                  durationYear: numericValue,
                                }));
                              }
                            }
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                            ];
                            if (
                              !/[0-9]/.test(e.key) &&
                              !allowedKeys.includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          placeholder="Enter year"
                          // required
                        />
                        Year
                        <input
                          type="number"
                          min="0"
                          name="durationMonth"
                          className="form-control"
                          value={formData?.durationMonth}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setFormData((prev) => ({
                                ...prev,
                                durationMonth: "",
                              }));
                            } else {
                              const numericValue = parseInt(value);
                              if (!isNaN(numericValue)) {
                                setFormData((prev) => ({
                                  ...prev,
                                  durationMonth: numericValue,
                                }));
                              }
                            }
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                              "Delete",
                            ];
                            if (
                              !/[0-9]/.test(e.key) &&
                              !allowedKeys.includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          placeholder="Enter month"
                          // required
                        />
                        Month
                      </div>
                    </div>

                    <div
                      className="col-md-12 mt-3"
                      style={{
                        paddingBottom: "25px",
                        paddingTop: "25px",
                      }}
                    >
                      <label>
                        Year wise Fees{" "}
                        <button
                          className="btn btn-sm btn-success"
                          type="button"
                          onClick={() => addItem()}
                        >
                          <i class="fas fa-plus"></i> Add
                        </button>
                      </label>
                      {items?.map((element, index) => (
                        <div
                          // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                          className="_form-inline row"
                          key={index}
                        >
                          <div className="col-md-6 mb-2 mt-1">
                            <label>Year number:</label>
                            <input
                              type="text"
                              class="form-control"
                              name="year"
                              placeholder={`Year ${index + 1}`}
                              value={element.year || 0}
                              onChange={(e) => handleMultiChange(index, e)}
                            />
                          </div>

                          <div className="col-md-6 mb-2 mt-1">
                            <label>Fees:</label>
                            <input
                              type="text"
                              class="form-control"
                              name="fees"
                              placeholder={`Fees Amount ${index + 1}`}
                              value={element.fees || 0}
                              onChange={(e) => handleMultiChange(index, e)}
                            />
                          </div>

                          {index ? (
                            <div
                              style={{
                                position: "absolute",
                                right: "25px",
                              }}
                            >
                              <i
                                class="fas fa-times"
                                style={{
                                  color: "#ff0000",
                                  cursor: "pointer",
                                  fontSize: "1em",
                                }}
                                onClick={() => removeProducts(index)}
                              ></i>
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Eligibility<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="form-control"
                        value={formData?.eligibility}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            eligibility: e?.target?.value,
                          }));
                        }}
                        placeholder="Eligibility"
                        required
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        Applicaion Date<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        id="name"
                        className="form-control"
                        value={formData?.applicationDate}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            applicationDate: moment(e?.target?.value).format(
                              "YYYY-MM-DD"
                            ),
                          }));
                        }}
                        placeholder="Applicaion Date"
                        required
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">Particulars</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.particulars}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            particulars: e?.target?.value,
                          }));
                        }}
                        placeholder="particulars"
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">Day Scholars</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.dayScholars}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            dayScholars: e?.target?.value,
                          }));
                        }}
                        placeholder="Day Scholars"
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <label htmlFor="name">
                        Eligibility in Details
                        <span className="text-danger">*</span>
                      </label>
                      <textarea
                        style={{ resize: "none" }}
                        type="text"
                        className="form-control"
                        value={formData?.longEligibility}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            longEligibility: e?.target?.value,
                          }));
                        }}
                        placeholder="Enter Eligibility in details"
                        required
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <label htmlFor="name">
                        Short Description<span className="text-danger">*</span>
                      </label>
                      <textarea
                        style={{ resize: "none" }}
                        type="text"
                        className="form-control"
                        value={formData?.shortDescription}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            shortDescription: e?.target?.value,
                          }));
                        }}
                        placeholder="Enter Short Description"
                        required
                      />
                    </div>

                    {/* <div className="col-md-6 mt-3">
                                <label htmlFor="name">
                                  Brochure<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="file"
                                  id="name"
                                  className="form-control"
                                  value={cityName}
                                  onChange={(e) => setCityName(e.target.value)}
                                  placeholder="Eligibility"
                                  required
                                />
                              </div> */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">Exams</label>
                      <Select
                        isMulti
                        options={options}
                        value={selectedExams}
                        onChange={setSelectedExams}
                        placeholder="Select Exams..."
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Brochure">
                        {uploading && "Uploading "}Brochure
                        {/*<span className="text-danger">*</span> */}
                      </label>
                      {!uploading && formData?.brochure && (
                        <>
                          {/* <img
                                    src={formData?.brochure}
                                    alt="Brochure Preview"
                                    style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                                  /> */}
                          <a
                            href={formData?.brochure}
                            target="_blank"
                            style={{ marginLeft: "10px" }}
                          >
                            {formData?.brochure
                              .split(".")
                              .pop()
                              .toLowerCase() === "pdf" ? (
                              <i className="fas fa-2x fa-file-pdf" />
                            ) : (
                              formData?.brochure
                                .split(".")
                                .pop()
                                .toLowerCase() === "doc" ||
                              (formData?.brochure
                                .split(".")
                                .pop()
                                .toLowerCase() === "docx" && (
                                <i className="fas fa-2x fa-file-word" />
                              ))
                            )}
                          </a>
                        </>
                      )}
                      <input
                        type="file"
                        ref={fileInputRef}
                        id="bannerImage"
                        className="form-control"
                        onChange={handleFileUpload}
                        // accept="image/*,.pdf,.doc,.docx"
                        accept=".pdf,.doc,.docx"
                        // required
                      />
                    </div>
                  </div>
                  {/* <div className=" d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  background: "#a2bae0",
                                  borderRadius: "13px",
                                }}
                              >
                                Add More
                              </button>
                            </div> */}
                  <div
                    className=" d-flex justify-content-center"
                    style={{ gap: "15px" }}
                  >
                    <button
                      disabled={updateLoading}
                      type="submit"
                      className="btn mt-3"
                      style={{
                        background: "rgb(133, 218, 79)",
                        borderRadius: "13px",
                      }}
                    >
                      {updateLoading ? "Saving data..." : "Update Course/Fees"}
                    </button>
                    <button
                      onClick={() => {
                        handleCancel();
                      }}
                      disabled={updateLoading}
                      type="button"
                      className="btn mt-3"
                      style={{
                        background: "#f77754",
                        borderRadius: "13px",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </section>
            </>
          ) : (
            <>
              <section className="chartBox_area">
                <input
                  type="text"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    width: "250px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
                <DataTable
                  // data={allData}
                  data={filteredData}
                  columns={columns}
                  pagination
                  responsive
                  highlightOnHover
                  customStyles={customStyles}
                />
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageCourseAndFees;
